import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TrackJS } from 'trackjs';

@Injectable()
export class TrackjsErrorInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const httpErrorLog = {
          message: error.message,
          method: req.method,
          url: req.url,
          urlWithParams: req.urlWithParams,
          status: error.status,
          statusText: error.statusText,
          response: error.error as Record<string, unknown>,
        };
        const trackjsError = `${error.status} : ${req.method} ${req.url}`;
        if (TrackJS.isInstalled()) {
          TrackJS.console.log(httpErrorLog);
          TrackJS.track(trackjsError);
        }
        return throwError(() => error);
      })
    );
  }
}
